import { Alert } from '../../store/types'
import { AlertsAction } from '../../store/actions/alerts'
import {
  PUSH_ALERT,
  REMOVE_ALERT,
} from '../../store/constants'

export interface AlertsReduxState {
  alerts: Alert[]
}

export const initialState: AlertsReduxState = {
  alerts: [],
}

// eslint-disable-next-line default-param-last
export function reducer(state: AlertsReduxState = initialState, action: AlertsAction) {
  switch (action.type) {
  case PUSH_ALERT:
    return {
      ...state,
      alerts: [...state.alerts, action.data],
    }

  case REMOVE_ALERT:
    return {
      ...state,
      alerts: state.alerts.filter(a => a.id !== action.data.id),
    }

  default:
    return state
  }
}
